export default "__VITE_ASSET__LfItdZ4M__"